var map = {
	"./16.png": 3,
	"./32.png": 4,
	"./48.png": 5,
	"./64.png": 6,
	"./favicon.ico": 7,
	"./favicon_114.png": 8,
	"./favicon_120.png": 9,
	"./favicon_144.png": 10,
	"./favicon_152.png": 11,
	"./favicon_167.png": 12,
	"./favicon_180.png": 13,
	"./favicon_57.png": 14,
	"./favicon_60.png": 15,
	"./favicon_72.png": 16,
	"./favicon_76.png": 17,
	"./favicon_fb.png": 18,
	"./windows_large.png": 19,
	"./windows_square.png": 20,
	"./windows_tiny.png": 21,
	"./windows_wide.png": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;